
import React from 'react';
import Navbar from '@/components/Navbar';
import FeaturesHero from '@/components/features/FeaturesHero';
import FinalCTA from '@/components/FinalCTA';
import Footer from '@/components/Footer';
import SectionLayout from '@/components/SectionLayout';
import CallToAction from '@/components/feature/CallToAction';
import AIAssistantsSection from '@/components/feature/AIAssistantsSection';
import IntelliFormsSection from '@/components/feature/IntelliFormsSection';
import FlowBuilderSection from '@/components/feature/FlowBuilderSection';
import SpotlightPagesSection from '@/components/feature/SpotlightPagesSection';

const Features = () => {
  return (
    <main className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <FeaturesHero />
      
      {/* Main Content Section - Added ID for scroll target */}
      <div id="features-content">
        {/* AI Assistants Section */}
        <SectionLayout 
          backgroundColor="bg-[#f7faff]" 
          paddingY="py-16 md:py-24" 
          className="relative"
          id="ai-assistants-section"
        >
          <AIAssistantsSection />
        </SectionLayout>
        
        {/* CTA Separator - Changed to full width by removing SectionLayout */}
        <div className="w-full bg-white py-0 relative border-t border-b border-gray-100">
          <CallToAction />
        </div>
        
        {/* IntelliForms Section */}
        <SectionLayout 
          backgroundColor="bg-[#f7faff]" 
          paddingY="py-16 md:py-24" 
          className="relative"
          id="intelliforms-section"
        >
          <IntelliFormsSection />
        </SectionLayout>
        
        {/* CTA Separator - Changed to full width by removing SectionLayout */}
        <div className="w-full bg-white py-0 relative border-t border-b border-gray-100">
          <CallToAction />
        </div>
        
        {/* Flow Builder Section */}
        <SectionLayout 
          backgroundColor="bg-[#f7faff]" 
          paddingY="py-16 md:py-24" 
          className="relative"
          id="flow-builder-section"
        >
          <FlowBuilderSection />
        </SectionLayout>
        
        {/* CTA Separator */}
        <div className="w-full bg-white py-0 relative border-t border-b border-gray-100">
          <CallToAction />
        </div>
        
        {/* Spotlight Pages Section */}
        <SectionLayout 
          backgroundColor="bg-[#f7faff]" 
          paddingY="py-16 md:py-24" 
          className="relative"
          id="spotlight-pages-section"
        >
          <SpotlightPagesSection />
        </SectionLayout>
      </div>
      
      {/* Final CTA Section */}
      <SectionLayout 
        backgroundColor="bg-[#FEE6D8]/50" 
        paddingY="py-16 md:py-24" 
        className="relative z-10"
        backgroundPattern="soft-mesh"
        patternOpacity={3}
      >
        <FinalCTA />
      </SectionLayout>
      
      <Footer />
    </main>
  );
};

export default Features;
